import GetCredentialsOauth2 from "../../../../src/pages/credentials/GetCredentialsOAuth2.js";
import * as React from 'react';
export default {
  GetCredentialsOauth2,
  React
};